import { render, staticRenderFns } from "./MyNoticeModal.vue?vue&type=template&id=794c7130&scoped=true"
import script from "./MyNoticeModal.vue?vue&type=script&lang=js"
export * from "./MyNoticeModal.vue?vue&type=script&lang=js"
import style0 from "./MyNoticeModal.vue?vue&type=style&index=0&id=794c7130&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794c7130",
  null
  
)

export default component.exports